import type { CSSProperties } from 'react';

import type { CSSMakeFn } from '@snowit/icetypes';

import slugify from './slugify';

/**
 * Checks whether the object has only the specified keys and no other keys.
 * @param obj - The object to check.
 * @param keys - The array of valid keys to check against.
 * @returns {boolean} - Returns true if the object has only the specified keys, otherwise false.
 */
export const hasKeys = (obj: object, keys: string[]): boolean => {
  if (Array.isArray(obj)) return false;
  const keysSet = new Set(keys);
  // quick check before using Object.keys and .every. if none of the keys appears it's pointless to check all object keys
  let atLeastOne = false;
  for (const key of keys) {
    if (Object.hasOwn(obj, key)) {
      atLeastOne = true;
      break;
    }
  }
  if (!atLeastOne) return false;
  //
  const objKeys = Object.keys(obj);
  if (!objKeys.length) return false;
  return objKeys.every((k) => keysSet.has(k));
};

export const cleanPPURegion = (input: string) => {
  if (!input) return null;
  return slugify(input);
};

export const removeWhiteSpaces = (input: string): string => {
  return input.replace(/\s+/g, '');
};

export const cleanEmail = (input: string): string => input.trim().replace(/\s+/g, '').toLowerCase();

export const makeCSS: CSSMakeFn = (input) => input as CSSProperties;
